import { CheckboxGroup } from "@heroui/react";
import { CustomCheckbox } from "../CustomCheckbox";

type Props = {
  pickOrRespond: ("pick" | "respond")[];
  setPickOrRespond: (value: ("pick" | "respond")[]) => void;
};

export function PickOrRespondFilter(props: Props) {
  const { pickOrRespond, setPickOrRespond } = props;

  return (
    <CheckboxGroup
      className="gap-1"
      orientation="horizontal"
      value={pickOrRespond}
      onChange={setPickOrRespond}
    >
      <CustomCheckbox value="pick">Pick</CustomCheckbox>
      <CustomCheckbox value="respond">Respond</CustomCheckbox>
    </CheckboxGroup>
  );
}
